import { CloudDoneOutlined } from "@mui/icons-material";
import { Box, Button, Tooltip, Typography } from "@mui/material";
import React from "react";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { NavLink } from "react-router-dom";

const QuoteBtn = (props) => {
  const { type, href, title, onClick, onSubmit } = props;
  return (
    <>
      <Tooltip title="Get A Quote">
        <Button
          onSubmit={onSubmit}
          onClick={onClick}
          type={type}
          startIcon=<CloudDoneOutlined />
          sx={{
            paddingX: "25px",
            paddingY: "10px",
            marginY: "10px",
            borderRadius: "15px",
            backgroundColor: "#005096",
          }}
          variant="contained"
          endIcon=<NavigateNextIcon />
          size="small"
        >
          <NavLink
            to={href}
            style={{
              color: "#fff",
              textDecoration: "none",
            }}
          >
            <Typography>{title}</Typography>
          </NavLink>
        </Button>
      </Tooltip>
    </>
  );
};

export default QuoteBtn;
